import React, { useState } from 'react';
import { motion } from 'framer-motion';
import MembershipForm from './MembershipForm';

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section 
      className="min-h-screen flex items-center justify-center text-center relative"
      style={{
        background: `linear-gradient(#fffc, #fffc), url(/assets/hero-background.webp) center / cover`
      }}
    >
      <div className="container">
        <motion.h1 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
          className="text-2xl sm:text-4xl lg:text-5xl xl:text-7xl font-light mb-8 mt-8 text-[#5A130E] px-4 !leading-[1.2]"
        >
          Behind every great woman...<br />
          is an other great woman.
        </motion.h1>
        <motion.button 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1 }}
          whileHover={{ scale: 1.05 }}
          className="button text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-4 mt-8 flex items-center justify-center mx-auto"
          onClick={() => setIsModalOpen(true)}
        >
          Join us!
        </motion.button>
      </div>
      <MembershipForm isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
};

export default Hero;